import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, } from '@angular/core';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs';
import { BObjectModel, InputModel, QResult, Select, SelectList } from '../../../models';
import { PipeStageModel } from '../../../models/formation';
import { CoreService, HttpService } from '../../../services';
import { ToastService } from '../../../toast';


@Component({
  selector: 'q-comp-stage-pipe-stage-creation',
  templateUrl: './stage-creation.component.html',
  styleUrls: ['./stage-creation.component.css'],
})

export class StagePipeStageCreationComponent {

  constructor(
    protected indParam: CoreService,
    protected toasts: ToastService,
    protected http: HttpService,
    protected modalService: NgbModal,
  ) { }

  @ViewChild('modal') modal: ElementRef;
  modalRef: any;
  @Input() colType: string;
  @Output() onModalClose = new EventEmitter<string>();



  public Model: PipeStageModel = new PipeStageModel();
  public BoModel = new BObjectModel();


  public ComboCursus: Array<Select> = [];
  public ComboCatalogues: Array<SelectList> = [];
  public ComboTypeOffres: Array<SelectList> = [];

  public ComboCategories: Array<SelectList> = [];
  public ComboProduits: Array<SelectList> = [];

  public ComboFormations: Array<SelectList> = [];
  public ComboActions: Array<SelectList> = [];

  public TypeSelection: string;


  /**
 * boolean permettant de récuperer l'action d'enregistrement en dehors du bo
 */
  public Save: boolean;

  public SelectedCursus: Select = new Select();
  public SelectedProduct: Select = new Select();
  public BoReady: boolean = false;

  /* #region popover*/
  public CatPopover: any;
  public CursusPopover: any;

  public valueCategorie: string = '';
  public valueCatalogue: string = '';
  public valueProduit: string = '';

  public valueOffre: string = '';
  public valueFormation: string = '';
  public valueAction: string = '';




  public openModal() {
    this.showComboType = this.valueCategorie = this.valueCatalogue = this.valueProduit = this.valueOffre = this.valueFormation = this.valueAction = '';
    this.modalRef = this.modalService.open(this.modal, { size: 'q-xxl', windowClass: 'qmodalover' });

    this.SelectedCursus.value = "Lier ce stage au cursus";
    /*   let defaultInputs = new Array<InputModel>();
       if (this.colType) {
         defaultInputs.push({ id: 'Etat_PRO', value: this.colType });
       }
       this.initBo(defaultInputs);*/

    this.BoReady = false;
    // Récupération des Cursus (=cycles)
    this.http.getHttp<QResult<Array<Select>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Display/GET_CURSUS/0`).subscribe((response: QResult<Array<Select>>) => {
      if (!response.HasError) {
        this.ComboCursus = response.Value;
        this.ComboCursus.unshift(new Select());
      }
    });


    this.SelectedProduct.id = '';
    this.SelectedProduct.value = 'Créer un stage';
    let getComboCatalogues = this.http.getHttp<QResult<Array<SelectList>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Display/GET_CATALOGUES_CATEGORIES_PRODUITS/0`);
    let getComboFormations = this.http.getHttp<QResult<Array<SelectList>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Display/GET_FORMATIONS_ACTIONS_SESSIONS/0`);

    // Récupérations des ensembles catalogues/catégories/produits & formation/action/session
    forkJoin([getComboCatalogues, getComboFormations]).subscribe((result: QResult<Array<SelectList>>[]) => {
      if (!result[0].HasError) {
        this.ComboCatalogues = result[0].Value;        
      }
      if (!result[1].HasError) {
        this.ComboTypeOffres = result[1].Value;
      }
    });

  }

  /**
   * Pour forcer l'enregistrement du BO depuis un bouton externe
   */
  public SaveBo() {
    if (this.Save) {
      this.Save = false;
    }
    setTimeout(() => {
      this.Save = true;
    }, 1);

  }

  public getEvent(bo: BObjectModel): void {
    // Création des liens après création du stage (uniquement si le bo a été créé)
    if (bo.IdDonneeFils && bo.IdDonneeFils != '0') {
      // Mise à jour de la date de modification
      const model: PipeStageModel = new PipeStageModel();
      model.Mode = 'ADD_LINKS_STAGE';
      model.IdStage = bo.IdDonneeFils;
      model.IdLinkedData = this.SelectedProduct.id;
      model.IdCursus = this.SelectedCursus.id;
      model.TypeData = this.TypeSelection;
      // Pas de loader ici ni d'attente de résultat
      this.http.postHttp<PipeStageModel>(`${this.indParam.AppParams.apiUrl}api/Pipe/Formation/Cursus/ADD_LINKS_STAGE`, model).subscribe(() => {
        this.toasts.showSuccessToast('Stage créé');

        this.onModalClose.emit(bo.IdDonneeFils);
        this.modalRef.close();
      });
    }
  }

  public onChangeSelect(value: any, selectType: string) {
    this.selectNone();
    if (value != '') {
      switch (selectType) {
        case 'CATALOGUE':
          this.ComboCategories = this.ComboCatalogues.find((e: SelectList) => e.id == value)?.ListSelect!;
          this.valueCategorie = '';
          this.valueProduit = '';
          break;
        case 'CATEGORIE':
          this.ComboProduits = this.ComboCategories.find((e: SelectList) => e.id == value)?.ListSelect!;
          this.valueProduit = '';
          break;
        case 'PRODUIT':
          this.selectProduct(this.ComboProduits.find((e: SelectList) => e.id == value)!, 'PROD')
          break;

        case 'OFFRE':
          this.ComboFormations = this.ComboTypeOffres.find((e: SelectList) => e.id == value)?.ListSelect!;
          this.valueFormation = '';
          this.valueAction = '';
          break;
        case 'FORMATION':
          this.ComboActions = this.ComboFormations.find((e: SelectList) => e.id == value)?.ListSelect!;
          this.valueAction = '';
          break;
        case 'ACTION':
          this.selectProduct(this.ComboActions.find((e: SelectList) => e.id == value)!, 'ACT');
          break;
      }
    }
  }

  public showComboType = '';
  public showCombo(type: string, popover: NgbPopover) {

    this.valueCategorie = '';
    this.valueCatalogue = '';
    this.valueProduit = '';

    this.valueOffre = '';
    this.valueFormation = '';
    this.valueAction = '';
    this.selectNone();
    this.showComboType = type;
    popover.close();
  }

  public OnChangeCursus(cursus: Select): void {
    if (cursus.id == "0") {
      this.SelectedCursus.id = "0";
      this.SelectedCursus.value = "Lier ce stage au cursus";
    } else {
      this.SelectedCursus = cursus;
    }

    this.CursusPopover.close();
  }

  /**
   * Choix "aucun produit / action"
   */
  public selectNone(): void {
    this.SelectedProduct.id = '';
    this.SelectedProduct.value = 'Créer un stage';
  }

  /**
   * Choix d'un produit / action
   */
  public selectProduct(product: SelectList, type: string): void {
    this.SelectedProduct.id = product.id;
    this.SelectedProduct.value = product.value;
    this.TypeSelection = type;
    this.AffectPropertyOnBO(type);
  }

  /**
    * Choix d'un produit / action & Affectation des valeurs aux propriétés du BO en cours de création en fonction du produit / action sélectionnée
    * @param type type d'objet sélectionné (Action ou produit)
    */
  AffectPropertyOnBO(type: string) {
    let defaultInputs = new Array<InputModel>();
    if (this.colType) {
      defaultInputs.push({ id: 'Etat_PRO', value: this.colType });
    }
    if (type != 'NONE') {
      // Récupération de la liste des inputs à remplir
      this.http.getHttp<QResult<Array<InputModel>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Display/GET_PROPERTY_${type}/${this.SelectedProduct.id}`).subscribe((response: QResult<Array<InputModel>>) => {
        if (!response.HasError) {
          response.Value.forEach((input: InputModel) => {
            defaultInputs.push({ id: input.id, value: input.value });
          });
          // réinitialisation des inputs du BO
          this.initBo(defaultInputs);
          this.BoReady = true;
        }
      });
    }
    else {
      // réinitialisation des inputs du BO
      this.initBo(defaultInputs);
      this.BoReady = true;
    }
  }

  /*#region private*/
  private initBo(defaultInputs: InputModel[]): void {
    this.BoModel = new BObjectModel();
    this.BoModel.IdDonneeFils = "0"
    this.BoModel.IdDonneePere = "1348";
    this.BoModel.IdentBO = "BO_STAGE";
    this.BoModel.IdRelation = "REL_BO_CENT_BO_STAGE";
    this.BoModel.ShowSaveButton = false;

    this.BoModel.DefaultInputs = defaultInputs;
  }

}

